import React from 'react';
import { connect } from 'react-redux';
import _reduce from 'lodash/reduce';
import _map from 'lodash/map';
import _get from 'lodash/get';
import fetcher from '../../../modules/ajio-fetch';
import { fetchGetJSONResHandler } from '../../../modules/ajio-fetch/utils';
import { showModal, hideModal } from '../../../actions/modal';
import StoreListModal from './StoreListModal';
import NavBar from './NavBar';
import { PAGE_OPTIONS_RETURN, PAGE_OPTIONS_PICKUP } from './config';
import './storepickup.scss';

class StorePickupContainer extends React.Component {
  constructor(props) {
    super(props);
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: props.match.path === '/store-pickup' ? 0.2 : 0.4
    };
    const { match: { path = '' } = {} } = this.props;
    this.receivedStoreUrlPath = path;

    this.storeType = this.receivedStoreUrlPath === '/store-pickup' ? 'pickup' : 'return';

    this.storeNavList =
      this.receivedStoreUrlPath === '/store-pickup' ? PAGE_OPTIONS_PICKUP : PAGE_OPTIONS_RETURN;

    this.observer = new IntersectionObserver((entries, observer) => {
      for (let i = 0; i < entries.length; i++) {
        const navId = entries[i].target.id;
        if (entries[i].isIntersecting) {
          this.setState({ navId });
          return;
        } else if (navId == 'testimonial' && !entries[i].isIntersecting) {
          const top = _get(entries, [i, 'boundingClientRect', 'top']);
          this.setState({ navId: top < 0 ? 'whystorepickup' : 'howitworks' });
        }
      }
    }, options);

    this.state = {
      navId: '',
      faqAndTestimonial: {},
      modal: {}
    };
  }

  setNavId = navId => {
    this.setState({ navId });
  };

  componentDidMount() {
    fetcher(`api/storepickup/storePickupFaqAndTestimonial/${this.storeType}`)
      .then(fetchGetJSONResHandler)
      .then(response => {
        this.setState({
          faqAndTestimonial: response || {}
        });
      })
      .catch(err => {
        console.log('storeListFromPincode err', err);
      });
  }

  showPincodeModal = pincode => {
    this.setModal({
      name: 'store-view',
      classes: 'modal-add-address',
      content: <StoreListModal receivedStoreUrlPath={this.receivedStoreUrlPath} pincode={pincode} />
    });
  };

  hidePincodeModal = () => {
    this.setState({ modal: {} });
  };

  setModal = modal => {
    this.setState({ modal }, () => {
      this.props.showModal(modal.name);
    });
  };

  render() {
    const { nav = [] } = this.storeNavList;
    const { navId, faqAndTestimonial } = this.state;
    return (
      <div className="store-pickup-container">
        {_map(nav, ({ Component, id, data = {} }) => (
          <Component
            key={id}
            indexStatesProps={{
              modal: this.state.modal,
              showPincodeModal: this.showPincodeModal,
              hidePincodeModal: this.hidePincodeModal
            }}
            receivedStoreUrlPath={this.receivedStoreUrlPath}
            data={data}
            observer={this.observer}
            faqAndTestimonial={faqAndTestimonial}
          />
        ))}
        <NavBar
          nav={nav}
          currentNavId={navId}
          setNavId={this.setNavId}
          faqAndTestimonial={faqAndTestimonial}
        />
      </div>
    );
  }
}

export default connect(null, {
  hideModal,
  showModal
})(StorePickupContainer);
